var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12 col-md-12 d-flex align-items-end justify-content-end"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.createNewAdministrator}},[_vm._v("Nova firma")])],1)]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-table',{staticClass:"border-left border-right border-bottom",attrs:{"items":_vm.administrators,"fields":_vm.fields,"striped":"","responsive":"","selectable":""},on:{"row-clicked":_vm.showAdministrator},scopedSlots:_vm._u([{key:"cell(is_ariba_enabled)",fn:function(data){return [_c('div',[_c('div',{style:({ 
              width: '15px', 
              height: '15px', 
              backgroundColor: data.item.is_ariba_enabled ? 'green' : 'gray', 
              borderRadius: '50%', 
              border: '2px solid #fff', 
              boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)', 
              margin: 'auto' 
            })})])]}},{key:"cell(order_status)",fn:function(data){return [_c('div',[_c('div',{style:({ 
              width: '15px', 
              height: '15px', 
                backgroundColor: !data.item.has_order_forms ? '' : 
                          (data.item.status === 'ALLOW_ORDERING' ? 'green' : 
                          (data.item.status === 'DISALLOW_ORDERING' ? 'orange' : 
                          (data.item.status === 'SOFT_ORDERED' ? 'red' : 'red'))), 
                borderRadius: '50%', 
                border: '2px solid #fff', 
                boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)', 
                margin: 'auto' 
              })})])]}}])})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }